import Vue from 'vue'
import SinisterTransformer from '../../transformers/extranet/SinisterTransformer'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const fetchSinisters = (param) => {
  let config = null
  if (param) {
    config = {
      params: param,
    }
  }

  return Vue.$http.get('extranet/ready/sinisters/', config)
    .then((response) => { return SinisterTransformer.fetchCollection(response.data) })
    .catch((err) => { throw err })
}

export default fetchSinisters


// WEBPACK FOOTER //
// ./src/services/extranet/fetchSinisters.js